module.exports = ":host {\n  height: auto; }\n  :host i, :host span {\n    vertical-align: middle; }\n"